<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="testimonial-page pt-227 pb-100">
    <Testimonial4Content />
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";
import Testimonial4Content from "../components/OurTeam/Testimonial4Content.vue";

export default defineComponent({
  name: "Testimonial4Page",
  components: {
    MainNavbar,
    MainFooter,
    Testimonial4Content,
  },
});
</script>

<style scoped>
.testimonial-page {
  padding: 100px 20px 20px 20px;
}
</style>
